import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import DOMPurify from "dompurify";
import { useMemo } from "react";

const ServiceCheckListModalFormStepOne = () => {
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settingsReducer.settings);
  const checklistSetting = settings.find(
    (item) => item.name === "CHECKLIST_TEXT",
  );
  const safeHtml = useMemo(() => {
    const value = checklistSetting?.value;
    if (
      !value ||
      value === "<p><br></p>" ||
      !value.replace(/<(.|\n)*?>/g, "").trim()
    ) {
      return null;
    }
    return DOMPurify.sanitize(value);
  }, [checklistSetting?.value]);
  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:service.checkList")} />
      <Row>
        <Col xs={12}>
          {safeHtml ? (
            <div dangerouslySetInnerHTML={{ __html: safeHtml }} />
          ) : (
            <div>{t("global:service.NoDataInAdminSettings")}</div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ServiceCheckListModalFormStepOne;
